import { Directive, ElementRef, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';

/** Parametres de requete, meme forme que la directive du Manager. */
export type TenantQuery = Record<string, string | number | boolean | undefined>;

/**
 * Equivalent BackStage de `TenantLinkDirective`.
 *
 * Meme selecteur et memes entrees que la directive du Manager, pour que les
 * composants du kit (`nav-item`, `nav-dev-item`) fonctionnent sans modification.
 * La difference est qu'il n'y a **pas de prefixe de locataire** : le chemin est
 * resolu comme une route absolue ordinaire.
 */
@Directive({
  selector: 'a[appTenantLink],button[appTenantLink]',
  host: {
    '[attr.href]': 'href()',
    '(click)': 'onClick($event)',
  },
})
export class TenantLinkDirective {
  readonly appTenantLink = input.required<string>();
  readonly tenantQuery = input<TenantQuery>({});

  private readonly router = inject(Router);
  private readonly isAnchor = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement.tagName === 'A';

  private readonly chemin = computed(() => '/' + this.appTenantLink().replace(/^\/+/, ''));

  /** `href` reel sur un `<a>`, nul sur un `<button>`. */
  protected readonly href = computed(() =>
    this.isAnchor
      ? this.router.serializeUrl(this.router.createUrlTree([this.chemin()], { queryParams: this.tenantQuery() }))
      : null,
  );

  protected onClick(event: Event): void {
    // Clic modifie sur une vraie ancre : on laisse le navigateur faire.
    if (
      this.isAnchor &&
      event instanceof MouseEvent &&
      (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0)
    ) {
      return;
    }
    event.preventDefault();
    void this.router.navigate([this.chemin()], { queryParams: this.tenantQuery() });
  }
}
